	<section *ngIf="treatment as t">
		<h1>{{'Edit Treatment' | translate}}</h1>

		<div class="main-container">

			<ux-product-visual
				[product]="t.product"
				[isDisplayedDuringOrder]="false"
			></ux-product-visual>

			<div class="data-container">

				<!-- TREATMENT DETAIL HEADER-->
				<ux-treatment-detail-header
					[treatment]="t"
					[patient]="t.patient"
					[user]="user$ | async"
				></ux-treatment-detail-header>

				<div class="treatment-control-buttons">
					<button mat-raised-button color="primary"
						matBadge="{{treatment.unreadPublicMessages?.length}}"
						matBadgeColor="warn"
						[matBadgeHidden]="treatment.unreadPublicMessages?.length > 0 ? false : true"
						(click)="onNotificationsButtonClicked()">
						@if(treatment.unreadPublicMessages?.length > 0){
							<i class="fal fa-envelope"></i>
						}@else {
							<i class="fal fa-envelope-open"></i>
						}
						{{'Notifications' | translate}}
					</button>
					<div class="right-buttons">
						<button mat-raised-button color="primary"
							*ngIf="showComplaintButton"
							(click)="onComplaintButtonClicked()">
							{{'Complaint' | translate}}
						</button>

						@if (isCostEstimateAvailable()) {
							<button
								mat-raised-button color="primary"
								[disabled]="isDownloadingCostEstimatePdf"
								(click)="onCostEstimate()">
								{{'Cost Estimate' | translate}}
							</button>
						}

						@if(isOrcadentTreatment()){
							<button mat-raised-button color="primary"
								(click)="openOrcadentQuestionnaireDialog()">
								<i class="fa-light fa-file"></i>
								{{'Treatment plan' | translate }}
							</button>
						}

						<button mat-raised-button color="primary"
							(click)="onDataExchangeButtonClicked()">
							<i class="fal fa-files"></i>
							{{'Treatment Files' | translate}}
						</button>

						<button *ngIf="showUpsButton"
							mat-raised-button color="primary"
							(click)="onUpsButtonClicked()">
							<i class="fa-brands fa-ups"></i>
							{{'UPS Abholservice' | translate}}
						</button>

						@if (getTreatmentWebviewers()?.length > 0 && (isAlignerTreatment(t) || isOrcadentTreatment())) {
							<button
								mat-raised-button color="primary"
								(click)="onWebViewersButtonClicked()">
								<i class="fal fa-arrow-up-right-from-square"></i>
								{{'WebViewers' | translate}}
							</button>
						}
					</div>
				</div>
				@if (getTreatmentWebviewers()?.length > 0 && !isAlignerTreatment(t) && !isOrcadentTreatment() ) {
					<mat-card>
						<mat-card-content>
							<ux-webviewer-preview [webviewers]="getTreatmentWebviewers()" />
						</mat-card-content>
					</mat-card>
				}


				<!-- PACKAGES PROFESSIONAL-->
				@if(showPackages){
					<mat-card>
						<mat-card-content>
							<div class="treatment-title">
								<h3>
									<i class="fas fa-arrow-alt-circle-right"></i>
									<span *ngIf="getAlignerPackages()?.next === 0">{{'Angefragt' | translate}} - </span>{{getAlignerProductName()}}
								</h3>
							</div>
							<ux-treatment-packages class="packages"
											[treatment]="t"
											[packages]="getAlignerPackages()"
							></ux-treatment-packages>
						</mat-card-content>
					</mat-card>
				}

				<!-- PACKAGES ORCADENT -->
				@if(showPackagesOrcadent){
					<mat-card>
						<mat-card-content>
							<h3>
								<i class="fas fa-arrow-alt-circle-right"></i>
								<span *ngIf="!isOrcadentTreatmentRunning()">{{'Proposed setup' | translate}} - </span>{{getOrcadentProductName()}}
							</h3>
							<ux-treatment-packages-orcadent
								[packages]="getOrcadentPackages()">
							</ux-treatment-packages-orcadent>
						</mat-card-content>
					</mat-card>
				}

				<!-- RELEASE DATA -->
				@if(t.schema_version >= 2 && t.status === TreatmentStatus.ReleaseRequested){
					<tm2-treatment-release
						[treatment]="treatment"
						(backButtonClicked)="onBackButtonClicked()"
					></tm2-treatment-release>
				}

				@if(t.status === TreatmentStatus.RefinementReleaseRequested){
					<tm2-refinement-release
						[plannedAligners]="getAlignerPackages()?.plannedRefinementAligners"
						[isDataVariant]="isDataVariant()"
						(releaseAction)="onReleaseRefinementButtonClicked()"
						(rejectAction)="onRejectRefinementButtonClicked()"
					>
					</tm2-refinement-release>
				}

				<!-- ASSOCIATED TREATMENTS -->
				<ux-treatment-relatives
					[childTreatments]="t.childTreatments"
					[parentTreatment]="t.parentTreatment"
					(treatmentSelected)="onGoToTreatmentClicked($event)">
				</ux-treatment-relatives>

				<!-- SPECIAL STATI -->
				<tm2-treatment-special-status
					*ngIf="showSpecialState"
					[status]="t.status"
				></tm2-treatment-special-status>
			</div>

		</div>

		<!-- Back-/Order next package button -->
		@if(t.status !== TreatmentStatus.ReleaseRequested){
			<div class="back-next-order-button-container">
				<button mat-raised-button
					(click)="onBackButtonClicked()">
					<i class="fal fa-chevron-double-left"></i> {{'Back' | translate}}
				</button>
				@if (t.schema_version >= 2 && !hideOrderNextPackageButton ) {
				<tm2-treatment-actions
					[orderablePackageType]="orderablePackageType"
					[treatment]="t"
					[wmsId]="(user$ | async).wmsId"
					(action)="onAction($event)"
				></tm2-treatment-actions>
				}
				@if (showOrderMemotainButton){
					<div matTooltip="{{'OrderMemotainPostProfessionalTooltip' | translate }}"
						 [matTooltipDisabled]="isOrderMemotainButtonEnabled()"
						 [matTooltipPosition]="'above'">
						<button mat-raised-button color="primary"
							[disabled]="!isOrderMemotainButtonEnabled()"
							(click)="onOrderMemotainClicked()"
							data-cy="orderMemotainPostProfessionalButton">
							<i class="fal fa-shopping-cart"></i> {{'OrderMemotainPostProfessional' | translate: ({price: 49})}}
						</button>
					</div>
				}
			</div>
		}

	</section>



